/**
 * Environment Variable Checker
 * This utility helps diagnose issues with environment variables
 */

/**
 * Checks if critical environment variables are properly configured
 * and logs the results to the console
 */
export const checkEnvironmentVariables = () => {
  // Check API URL
  const apiUrl = process.env.REACT_APP_API_URL;

  // Check API Key
  const apiKey = process.env.REACT_APP_API_KEY;

  // In development mode, we could log warnings if environment variables are missing
  if (process.env.NODE_ENV === 'development') {
    if (!apiUrl) {
      console.warn('REACT_APP_API_URL is not set');
    }

    if (!apiKey) {
      console.warn('REACT_APP_API_KEY is not set - API requests will fail!');
    }
  }

  return {
    apiUrlConfigured: !!apiUrl,
    apiKeyConfigured: !!apiKey
  };
};

export default checkEnvironmentVariables;
